// extracted by mini-css-extract-plugin
export default {"name":"iNvKLrlUAohJhL_aWlfm","role":"DnQBJ2OjjUZSD8AHzerL","small":"uig3W14QhdzinfefD5ul","placeHolderShimmer":"kyGvOfg1dilgM5_rO4lg"};